<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>New Crawler</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-autocomplete
                :loading="loading"
                v-model="entity"
                :items="reviewedEntities"
                cache-items
                :search-input.sync="searchTerm"
                hide-details
                return-object
                item-text="title"
                item-value="title"
                placeholder="Select Entity"
                no-data-text="Type a name of an entity to search"
                outlined
                chips
                dense
                @change="updateFields"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3" v-if="entity">
            <v-flex>
              <div class="subtitle-2 mb-1">Instagram Url</div>
              <v-text-field
                v-model="instagramUrl"
                hide-details
                dense
                outlined
                placeholder="Instagram Url"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";
import "firebase/app";
export default {
  props: {
    collection: {
      type: String,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      searchTerm: "",
      loading: false,
      dialog: false,
      entity: "",
      instagramUrl: "",
    };
  },
  computed: {
    ...mapState("$_entity", ["crawlers", "reviewedEntities"]),
    changeFields() {
      return {
        entity: this.entity,
        instagramUrl: this.instagramUrl,
        lastChecked: firebase.firestore.FieldValue.serverTimestamp(),
        lastPostOnIG: firebase.firestore.FieldValue.serverTimestamp(),
        state: "active",
        isGallerySetup: false
      };
    },
  },
  watch: {
    searchTerm: _.debounce(function (e) {
      e && this.searchEntities(e);
    }, 300),
  },
  methods: {
    ...mapActions({
      createNewCrawler: "$_entity/createNewSubscriber",
      updateEntity: "$_entity/updateContent",
      getCrawlers: "$_entity/getSubscribers",
      getEntities: "$_entity/getContent",
      searchEntitiesAction: "$_entity/searchContent",
    }),
    updateFields() {
      this.instagramUrl = this.entity.instagram;
    },
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp;
        return moment(temp, "HH:mm").format("LT");
      } else {
        return 0;
      }
    },
    addDayTime() {
      this.$refs.scheduleDialogRef.toggleDialog();
      //   this.dayTimeDialog = true;
      //   this.schedule.push({
      //     day: 0,
      //     time: "",
      //   });
    },
    searchEntities(searchTerm) {
      this.loading = true;
      console.log("searching Tags: ", searchTerm);

      this.searchEntitiesAction({
        collection: "entities",
        mutation: "updateReviewedEntities",
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    cancel() {
      this.entity = "";
      this.instagramUrl = "";
      this.dialog = false;
    },
    save() {
      console.log(this.changeFields);
      this.createNewCrawler({
        details: this.changeFields,
        collection: this.collection,
        type: "crawler",
      }).then(() => {
        this.updateEntity({
          details: {
            id: this.entity.id,
            instagram: this.instagramUrl,
          },
          collection: "entities",
          type: "Entity",
        });

        this.cancel();

        this.getCrawlers({
          type: "crawler",
          collection: this.collection,
          mutation: "updateCrawlers",
        });
      });
    },
  },
};
</script>

<style>
</style>

          